export interface MapDefaults {
    bordercolor: string;
    lakescolor: string;
    shadowcolor: string;
    shadowOpacity: number;
    namescolor: string;
    namesShadowColor: string;
}

export interface StateData {
    namesId: string;
    name: string;
    slug: string;
    upcolor: string;
    overcolor: string;
    downcolor: string;
    enable: boolean;
}

export interface MapConfig {
    default: MapDefaults;
    states: { [key: string]: StateData };
}

export class ResponsiveMap {
    map_config: MapConfig;
    stateurlbase: string;

    constructor(map_config: MapConfig, stateurlbase: string) {
        this.map_config = map_config;
        this.stateurlbase = stateurlbase;
    }

    drawMap() {
        for (var state in this.map_config.states) {
            this.addEvent(state);
        }
        const mapdefault = this.map_config.default;
        const $lakesPath = $("#lakes").find("path");
        //lakes's color and border color
        if ($lakesPath.eq(0).attr("fill") != "undefined") {
            $lakesPath.attr({ "fill": mapdefault.lakescolor }).css({
                "stroke": mapdefault.bordercolor,
            });
        }

        //configuration for title text's shadow
        /*$('.tip').css({
            'box-shadow': '1px 2px 4px ' + mapdefault['namesShadowColor'],
            '-moz-box-shadow': '2px 3px 6px ' + mapdefault['namesShadowColor'],
            '-webkit-box-shadow': '2px 3px 6px ' + mapdefault['namesShadowColor'],
        });*/

        const $shadowPath = $("#shadow").find("path");

        //configuration for map shadow
        if ($shadowPath.eq(0).attr("fill") != "undefined") {
            let shadowOpacity = mapdefault.shadowOpacity;
            if (shadowOpacity >= 100) {
                shadowOpacity = 1;
            } else if (shadowOpacity <= 0) {
                shadowOpacity = 0;
            } else {
                shadowOpacity = shadowOpacity / 100;
            }

            $shadowPath.attr({
                "fill": mapdefault.shadowcolor,
                "fill-opacity": shadowOpacity,
            });
        }
    }

    addEvent(id: string) {
        const mapdefault = this.map_config.default;
        const _obj = $("#" + id);
        const stateconfig = this.map_config.states[id];
        const stateurlbase = this.stateurlbase;
        const _Textobj = $("#" + id + "," + "#" + stateconfig.namesId);

        $("#" + stateconfig.namesId).find("tspan").attr({
            "fill": mapdefault.namescolor,
        });

        _obj.attr({
            "fill": stateconfig.upcolor,
            "stroke": mapdefault.bordercolor,
        });
        if (stateconfig.enable) {
            _Textobj.attr({ "cursor": "pointer" });
            _Textobj.on("mouseenter", function () {
                //moving in/out effect
                //$('#tip').show().html(stateconfig['name']);
                _obj.css({ "fill": stateconfig.overcolor });
            });
            _Textobj.on("mouseleave", function () {
                //$('#tip').hide();
                _obj.css({ "fill": stateconfig.upcolor });
            });
            //clicking effect
            _Textobj.on("mousedown", function () {
                _obj.css({ "fill": stateconfig.downcolor });
            });
            _Textobj.on("mouseup", function () {
                _obj.css({ "fill": stateconfig.overcolor });
                window.location.href = stateurlbase + stateconfig.slug;
            });
            _Textobj.on("mousemove", function (e) {
                //var x = e.pageX - 20, y = e.pageY + (-38);
                //var tipw = $('#tip').outerWidth(), tiph = $('#tip').outerHeight(),
                //x = (x + tipw > $(document).scrollLeft() + $(window).width()) ? x - tipw - (20 * 2) : x
                //y = (y + tiph > $(document).scrollTop() + $(window).height()) ? $(document).scrollTop() + $(window).height() - tiph - 10 : y
                //$('#tip').css({ left: x, top: y })
            });
        } else {
            _Textobj.attr({ "cursor": "default" });
        }
    }
}
